import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '@/services/api';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.forgotPassword(email);
    } catch {
      // backend always returns 200; never reveal account existence
    } finally {
      setLoading(false);
      setDone(true);
    }
  };

  return (
    <>
      <Navbar />
      <main className="w-full bg-background-50 min-h-[calc(100vh-200px)] flex items-center justify-center">
        <div className="w-full max-w-md mx-auto px-4 py-10">
          <div className="bg-background-50 rounded-xl border border-background-200 p-6 md:p-8">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 text-center mb-6">找回密码</h1>
            {done ? (
              <p className="text-sm text-foreground-600 text-center">
                若该邮箱已注册，我们已发送重置链接，请查收邮件（30分钟内有效）。
              </p>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <label htmlFor="email" className="block text-foreground-700 text-sm font-medium mb-1.5">注册邮箱</label>
                  <input
                    id="email" type="email" required value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="请输入注册邮箱"
                    className="w-full bg-background-50 border border-background-300 rounded-md px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  />
                </div>
                <button type="submit" disabled={loading}
                  className="w-full py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60">
                  {loading ? '提交中...' : '发送重置链接'}
                </button>
              </form>
            )}
            <p className="text-sm text-center mt-6">
              <Link to="/login" className="text-primary-600 hover:text-primary-700">返回登录</Link>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
